var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rbbox"},[(_vm.showChart)?_c('div',{staticClass:"systemRbCourse_line",attrs:{"id":"systemRbCourse_line"}}):_c('div',{staticClass:"empty flex-column-center"},[_c('el-empty',{attrs:{"description":"暂无数据"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }